import React from "react";
import * as ReactDOM from "react-dom";
import { Button, Modal, Toast, Badge, ListView } from "antd-mobile";
import { post } from "../../utils/request";
import { href } from "../../utils/util";
import api from "./api";
import defaultImg from "./default.png";

import "./index.less";

const NUM_SECTIONS = 10;
const NUM_ROWS_PER_SECTION = 10;
let pageIndex = 0;

let dataBlobs = {};
let sectionIDs = [];
let rowIDs = [];
function genData(pIndex = 0) {
  for (let i = 0; i < NUM_SECTIONS; i++) {
    const ii = pIndex * NUM_SECTIONS + i;
    const sectionName = `Section ${ii}`;
    sectionIDs.push(sectionName);
    dataBlobs[sectionName] = sectionName;
    rowIDs[ii] = [];

    for (let jj = 0; jj < NUM_ROWS_PER_SECTION; jj++) {
      const rowName = `S${ii}, R${jj}`;
      rowIDs[ii].push(rowName);
      dataBlobs[rowName] = rowName;
    }
  }
  sectionIDs = [...sectionIDs];
  rowIDs = [...rowIDs];
}

class Find extends React.Component {
  constructor(...args) {
    super(...args);

    const getSectionData = (dataBlob, sectionID) => dataBlob[sectionID];
    const getRowData = (dataBlob, sectionID, rowID) => dataBlob[rowID];
    const dataSource = new ListView.DataSource({
      getRowData,
      getSectionHeaderData: getSectionData,
      rowHasChanged: (row1, row2) => row1 !== row2,
      sectionHeaderHasChanged: (s1, s2) => s1 !== s2,
    });

    this.state = {
      tabName: 1,
      dataSource,
      isLoading: true,
      hasMore: true,
      height: (document.documentElement.clientHeight * 10) / 4,
      data: [],
      skipCount: 0,
      pageSize: 10,
    };
  }

  componentDidMount() {}

  componentWillMount() {
    this.init();
  }

  init() {
    sectionIDs = [];
    rowIDs = [];
    dataBlobs = {};
    pageIndex = 0;

    genData();
    this.getList();
  }

  viewPort = () => {
    let u = navigator.userAgent.toLowerCase();
    return {
      isWeixin: u.indexOf("micromessenger") > -1,
      isQQ: u.indexOf("qq/") > -1,
      trident: u.indexOf("trident") > -1, //IE内核
      presto: u.indexOf("presto") > -1, //opera内核
      webKit: u.indexOf("applewebkit") > -1, //苹果、谷歌内核
      gecko: u.indexOf("gecko") > -1 && u.indexOf("khtml") == -1, //火狐内核
      mobile: !!u.match(/applewebkit.*mobile.*/) || !!u.match(/applewebkit/), //是否为移动终端
      ios: !!u.match(/\(i[^;]+;( u;)? cpu.+mac os x/), //ios终端
      android: u.indexOf("android") > -1 || u.indexOf("linux") > -1, //android终端或者uc浏览器
      iPhone: u.indexOf("iphone") > -1 || u.indexOf("mac") > -1, //是否为iPhone或者QQHD浏览器
      iPad: u.indexOf("ipad") > -1, //是否iPad
      webApp: u.indexOf("safari") == -1, //是否web应该程序，没有头部与底部
    };
  };

  getList(type) {
    const { skipCount, pageSize } = this.state;

    post({
      url: this.state.tabName === 1 ? api.selectAppNewsList : api.querySafeList,
      data: {
        releaseChannel: 2,
        skipCount: skipCount * pageSize,
        pageSize: pageSize,
      },
    }).then(
      (res) => {
        // console.log('查询列表', res)
        // Toast.info(res.msg,1);
        if ((res.result === "success" && res.data) || res.data.length > 0) {
          this.setState(
            {
              data: res.data,
            },
            () => {
              if (sectionIDs.length >= res.count) {
                this.setState({
                  hasMore: false,
                });
              }
              if (type) {
                this.setState({
                  dataSource: this.state.dataSource.cloneWithRowsAndSections(
                    dataBlobs,
                    sectionIDs,
                    rowIDs
                  ),
                  isLoading: false,
                });
              } else {
                const hei =
                  document.documentElement.clientHeight -
                  ReactDOM.findDOMNode(this.lv).parentNode.offsetTop;
                this.setState({
                  dataSource: this.state.dataSource.cloneWithRowsAndSections(
                    dataBlobs,
                    sectionIDs,
                    rowIDs
                  ),
                  isLoading: false,
                  height: hei,
                });
              }
            }
          );
        } else {
        }
      },
      (res) => {
        console.log("查询列表失败", res);
      }
    );
  }

  onEndReached = (event) => {
    // load new data
    // hasMore: from backend data, indicates whether it is the last page, here is false
    if (this.state.isLoading || !this.state.hasMore) {
      return;
    }
    console.log("reach end", event);
    this.setState({ isLoading: true });
    setTimeout(() => {
      pageIndex++;
      genData(pageIndex);
      this.setState(
        {
          skipCount: pageIndex,
        },
        () => {
          this.getList(1);
        }
      );
    }, 1000);
  };

  company(num) {
    let company = "";
    if (num >= 1000) {
      company = "k";
    }
    if (num >= 10000) {
      company = "w";
    }
    return num + "" + company;
  }
  openNewWeb(url) {
    let viewPort = this.viewPort();
    if (viewPort.ios || viewPort.iPhone || viewPort.iPad) {
      if (window.webkit) {
        window.webkit.messageHandlers.openNewWeb.postMessage({ url });
      }
    } else {
      if (window.huilian) {
        window.huilian.openNewWeb(url);
      }
    }
  }

  render() {
    const { data, urlOps } = this.state;
    // let index = data.length - 1;
    let index = 0;
    const row = (rowData, sectionID, rowID) => {
      let obj = {};
      if (index <= data.length - 1) {
        obj = data[index++];
      } else {
        return <div></div>;
      }

      return (
        <div
          className="FindItem"
          key={rowID}
          onClick={() => {
            if (this.state.tabName === 1) {
              this.openNewWeb(`/findDetail?id=${obj.contentId}`);
            } else {
              window.Countly.q.push([
                "add_event",
                {
                  key: "Discovery_SafetyTraining_Details_Ck",
                  segmentation: {},
                },
              ]);
              React.$hlInsight.track("Discovery_SafetyTraining_Details_Ck", {});
              // window.Countly.q.push(['add_event', {
              //     key:'Discovery_SafetyTraining_Details_Ck',
              // }]);
              this.openNewWeb(obj.contentLinkUrl);
            }
          }}
        >
          <div className="left">
            <h2>{obj.contentTitle}</h2>
            <div className="source">
              <span>{obj.gmtCreate.slice(0, 10)}</span>
              {/* <span>{this.company(obj.appReadingVolume || 0)}人浏览</span> */}
            </div>
          </div>
          <div className="right">
            <div
              style={{
                background: `url(${
                  obj.indexImg || defaultImg
                }) no-repeat center center`,
                backgroundSize: "cover",
              }}
            ></div>
          </div>
        </div>
      );
    };

    return (
      <div className="FindBox">
        <div className="navBox">
          <a
            className={this.state.tabName === 1 ? "active" : ""}
            onClick={() => {
              if (this.state.tabName === 1) {
                return;
              }
              href(`/find`, "");
            }}
          >
            动态
          </a>
          <a
            className={this.state.tabName === 2 ? "active" : ""}
            onClick={() => {
              window.Countly.q.push([
                "add_event",
                {
                  key: "Discovery_Menu_SafetyTrainingTab_Ck",
                  segmentation: {},
                },
              ]);
              React.$hlInsight.track("Discovery_Menu_SafetyTrainingTab_Ck", {});
              if (this.state.tabName === 2) {
                return;
              }
              href(`/findSafe`, "");
            }}
          >
            安全培训
          </a>
        </div>
        <ListView
          className="am-list"
          ref={(el) => (this.lv = el)}
          dataSource={this.state.dataSource}
          renderFooter={() => (
            <div style={{ padding: 30, textAlign: "center" }}>
              {this.state.isLoading ? "加载中..." : "已经到底了！"}
            </div>
          )}
          renderRow={row}
          style={{
            height: this.state.height,
            overflow: "auto",
          }}
          pageSize={10}
          onScroll={() => {
            console.log("scroll");
          }}
          scrollRenderAheadDistance={500}
          onEndReached={this.onEndReached}
          onEndReachedThreshold={10}
        />
      </div>
    );
  }
}
export default Find;



// WEBPACK FOOTER //
// ./src/find/index/index.js